import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxsModule } from '@ngxs/store';
import { CityState } from '@store/place/city/city.state';

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([CityState])],
})
export class PlaceStoreModule {}
